import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getGpsDevices = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/gps?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token,
            notCachedResponse: true
        }
    });
